export enum Experiment {
    WebCabinetAaTest = 'YGw__001__cancellation_flow',
}

export enum ActiveGroup {
    A = 'A',
    Default = 'Default',
    Control = 'Control',
}
